import React from "react";

export default function NotFound(props) {
  return <h1>No page found at {location.pathname}</h1>;
}
